import type { SVGProps } from 'react';
import * as React from 'react';

const PlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="outline/plus">
      <path
        id="Icon"
        d="M12 4V12M12 12V20M12 12L20 12M12 12H4"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default PlusIcon;
